<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="4"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-12 mt-4">
          <idx-card class="mb-4" :title="`${this.$t('newAction.nameAction')}`">
            <input
              type="text"
              :value="action.name"
              id="action-name-id"
              class="form-control"
              disabled="disabled"
            />
          </idx-card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <idx-card
            :title="`${this.$t('newAction.stepThree.titleIndicators')}`"
          >
            <div class="row mb-2 no-gutters">
              <div class="col-3">
                <label for
                  >{{ $t('newAction.stepThree.labels.addIndicators') }}:</label
                >
                <input
                  v-model="columnName"
                  type="text"
                  class="form-control mt-2"
                  :placeholder="`${this.$t(
                    'newAction.stepThree.enterIndicatorsName',
                  )}`"
                  @keyup.enter="addColumn"
                  :disabled="sending"
                />
              </div>
              <div class="col-9">
                <div class="drop-indicators">
                  <button
                    class="btn btn-primary"
                    style="margin-top: 39px"
                    @click="addColumn"
                  >
                    {{ $t('newAction.stepThree.buttonAddColumn') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
                <span>{{ $t('newAction.stepThree.addedIndicators') }}: </span>
                <table class="table table-striped mt-3">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('newAction.stepThree.indicator') }}
                      </th>
                      <th
                        scope="col"
                        class="indicator-th"
                        v-for="(indicatorHeader, i) in indicatorHeaders"
                        :key="i"
                      >
                        {{ indicatorHeader.header }}
                        <span
                          :id="indicatorHeader.header"
                          class="indicator-info-icon"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'info-circle']"
                            style="font-size: 15px; color: #c1c1c1"
                          />
                        </span>
                        <b-popover
                          :target="indicatorHeader.header"
                          :title="indicatorHeader.header"
                          triggers="hover"
                          placement="top"
                          :content="indicatorHeader.content"
                        ></b-popover>
                      </th>
                      <th scope="col">
                        {{ $t('newAction.stepThree.remove') }}
                      </th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="indicators"
                    tag="tbody"
                    id="dtable"
                    @change="handleSort"
                  >
                    <tr v-for="(indicator, index) in indicators" :key="index">
                      <td>
                        <font-awesome-icon
                          :icon="['fas', 'ellipsis-v']"
                          class="ellipsis"
                        />
                        {{ indicator.label }}
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('ih1', indicator.id, $event)"
                          v-model="indicator.ih1"
                          :disabled="
                            (allIh1Disabled && !indicator.ih1) ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('ih2', indicator.id, $event)"
                          v-model="indicator.ih2"
                          :disabled="
                            (allIh2Disabled && !indicator.ih2) ||
                            indicator.ih1 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="
                            indicatorRules('report', indicator.id, $event)
                          "
                          v-model="indicator.report"
                          :disabled="indicator.auxiliary || indicator.clientId"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('map', indicator.id, $event)"
                          v-model="indicator.map"
                          :disabled="
                            (allMapDisabled && !indicator.map) ||
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('date', indicator.id, $event)"
                          v-model="indicator.date"
                          :disabled="
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="
                            indicatorRules('auxiliary', indicator.id, $event)
                          "
                          v-model="indicator.auxiliary"
                          :disabled="
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.report ||
                            indicator.map ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          :onclick="
                            habilitAnonymous(indicator.id, indicator.clientId)
                          "
                          @input="
                            indicatorRules('clientId', indicator.id, $event)
                          "
                          v-model="indicator.clientId"
                          :disabled="
                            (allClientIdDisabled && !indicator.clientId) ||
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="
                            indicatorRules('expiration', indicator.id, $event)
                          "
                          v-model="indicator.expiration"
                          :disabled="!indicator.date"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          :disabled="indicator.clientId"
                          @input="
                            indicatorRules('anonymous', indicator.id, $event)
                          "
                          v-model="indicator.anonymous"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <button
                          @click="removeColumn(index, indicator.id)"
                          class="btn btn-outline-danger"
                        >
                          <font-awesome-icon :icon="['fa', 'trash-alt']" />
                        </button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </idx-card>
        </div>
      </div>
      <div v-if="action.channel !== 'widget'" class="row mt-5">
        <div class="col-12">
          <idx-card :title="`${this.$t('newAction.stepThree.titleLayout')}`">
            <div class="row mb-4">
              <div class="col-12 text-right">
                <button
                  @click="downloadModel"
                  class="btn btn-primary mr-2"
                  :disabled="sending"
                >
                  <font-awesome-icon :icon="['fas', 'download']" />
                  {{ $t('newAction.stepThree.downloadModelButton') }}
                </button>
                <button
                  class="btn btn-outline-danger"
                  :title="`${this.$t('newAction.stepThree.titleClearTable')}`"
                  @click="cleanTable"
                >
                  <font-awesome-icon :icon="['fa', 'trash-alt']" />
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div v-if="this.loading" class="text-center">
                  <b-spinner
                    variant="success"
                    type="grow"
                    label="Spinning"
                    class="bg-primary"
                  ></b-spinner>
                </div>
                <b-table
                  v-else
                  striped
                  responsive
                  :fields="columns"
                  :items="submitClients"
                >
                </b-table>
                <div class="more-items" v-if="fileLength > 0">
                  <h5>
                    {{ submitClients.length + fileLength }}
                    {{ $t('newAction.stepThree.itens') }}
                  </h5>
                </div>
              </div>
            </div>
          </idx-card>
        </div>
      </div>
      <div v-if="this.checkQuota" class="col-12 text-center">
        <b-spinner
          variant="success"
          type="grow"
          label="Spinning"
          class="bg-primary"
        ></b-spinner>
      </div>
      <div v-else-if="action.channel !== 'widget'" class="row mt-5">
        <div class="col-6">
          <idx-card
            :title="`${this.$t('newAction.stepThree.titleImportData')}`"
          >
            <div class="row">
              <div class="col-8">
                <p>{{ $t('newAction.stepThree.importCustomersXLS') }}:</p>
                <b-form-file
                  :browse-text="`${this.$t('newAction.stepThree.importFile')}`"
                  :placeholder="`${this.$t('newAction.stepThree.dragFile')}`"
                  :drop-placeholder="`${this.$t(
                    'newAction.stepThree.dropFile',
                  )}`"
                  ref="file-input"
                  accept=".txt,.xlsx,.csv"
                  v-model="submitFile"
                ></b-form-file>
                <div class="text-right" style="padding: 5px 0"></div>

                <b-modal ref="processingModal" :title="`${this.$t('actionUploadModal.title')}`" hide-footer>
                  <p>
                    {{this.$t('actionUploadModal.description')}}
                  </p>
                </b-modal>
              </div>
              <div class="col-4">
                <div class="text-center">
                  <span>{{ $t('newAction.stepThree.insertCustomers') }}:</span>
                  <br />
                  <button
                    class="btn btn-outline-primary mt-3"
                    v-b-modal.modal-add-user
                    :disabled="this.submitFile ? true : false"
                  >
                    <font-awesome-icon :icon="['fa', 'user-plus']" />
                  </button>
                </div>
                <b-modal
                  id="modal-add-user"
                  size="lg"
                  :title="`${this.$t('newAction.stepThree.titleImportData')}`"
                  @ok="insertUser"
                  @hidden="closeModal"
                >
                  <form id="frm-newUser">
                    <div class="form-group row">
                      <label
                        :for="columns[0].key"
                        class="col-sm-2 col-form-label"
                      >
                        {{ columns[0].label }}
                      </label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          class="form-control"
                          :name="`${columns[0].key}`"
                          :placeholder="
                            $t('newAction.stepThree.informFieldName', {
                              nameField: `${columns[0].label}`,
                            })
                          "
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        :for="columns[1].key"
                        class="col-sm-2 col-form-label"
                      >
                        {{ columns[1].label }}
                      </label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          class="form-control"
                          :name="`${columns[1].key}`"
                          v-model="columns[1].value"
                          :placeholder="
                            $t('newAction.stepThree.informFieldEmail', {
                              emailField: `${columns[1].label}`,
                            })
                          "
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        :for="columns[2].key"
                        class="col-sm-2 col-form-label"
                      >
                        {{ columns[2].label }}
                      </label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          class="form-control"
                          :name="`${columns[2].key}`"
                          :placeholder="`Informe o campo ${columns[2].label}`"
                          v-model="columns[2].value"
                          v-mask="'(##) #####-####'"
                        />
                      </div>
                    </div>
                    <div v-for="(column, i) in columns" :key="i">
                      <div class="form-group row" v-if="i > 2">
                        <label
                          :for="column.key"
                          class="col-sm-2 col-form-label"
                        >
                          {{ column.label }}
                        </label>
                        <div class="col-sm-10">
                          <input
                            type="text"
                            class="form-control"
                            :name="`${column.key}`"
                            :placeholder="
                              $t('newAction.stepThree.informFieldPhone', {
                                emailPhone: `${column.label}`,
                              })
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </b-modal>
                <b-toast
                  id="example-toast"
                  title="BootstrapVue"
                  static
                  no-auto-hide
                  >{{ $t('newAction.stepThree.failedAddCustomer') }}</b-toast
                >
              </div>
            </div>
          </idx-card>
        </div>
        <div class="col-6">
          <idx-card
            :title="`${this.$t('newAction.stepThree.titleScheduling')}`"
          >
            <div class="submit-action">
              <b-form-group class="mt-3">
                <b-form-radio-group
                  id="sms-radio-group"
                  v-model="$store.state.actions.schedule"
                >
                  <b-form-radio value="now">
                    <template v-if="action.channel === 'click-to-call'"
                      >Importar agora</template
                    >
                    <template v-else>{{
                      $t('newAction.stepThree.shootNow')
                    }}</template></b-form-radio
                  >
                  <b-form-radio value="after">
                    <template v-if="action.channel === 'click-to-call'"
                      >Agendar importação</template
                    ><template v-else>
                      {{ $t('newAction.stepThree.scheduleShooting') }}</template
                    ></b-form-radio
                  >
                </b-form-radio-group>
              </b-form-group>
              <div style="flex: 1; display: flex; justify-content: flex-end">
                <button
                  @click="handleSubmit"
                  :disabled="disableSubmitButton"
                  class="btn btn-primary"
                  style="color: white"
                >
                  <font-awesome-icon :icon="['fas', 'paper-plane']" />
                  <template v-if="schedule === 'after'">
                    <span class="ml-2">{{
                      $t('newAction.stepThree.toSchedule')
                    }}</span>
                  </template>
                  <template v-else>
                    <template v-if="action.channel !== 'click-to-call'">
                      <span class="ml-2">{{
                        $t('newAction.stepThree.shoot')
                      }}</span></template
                    >
                    <template v-else><span>Importar</span></template>
                  </template>
                </button>
              </div>
            </div>
            <div class="schedule-action" v-if="schedule === 'after'">
              <vc-date-picker
                :locale="countryLanguage"
                mode="single"
                color="green"
                :min-date="new Date()"
                v-model="date"
              >
                <b-input type="text" :value="dateFormat(date)"></b-input>
              </vc-date-picker>
              <span>&nbsp;&nbsp;às&nbsp;</span>
              <input
                type="text"
                id="schedule-time"
                class="form-control ml-2"
                v-model="$store.state.actions.scheduleInfo.time"
                v-mask="'##:##'"
              />
            </div>
          </idx-card>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 footer-buttons-area">
          <button @click="$router.back()" class="btn btn-info">
            {{ $t('genericMessages.goBack') }}
          </button>
          <button @click="saveChanges" class="btn btn-info">
            {{ $t('newAction.stepOne.saveChanges') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import draggable from 'vuedraggable';
import swal from 'sweetalert';
import { mapActions, mapState } from 'vuex';
import validator from 'validator';
import { mapFields } from 'vuex-map-fields';
import XLSX from 'xlsx';
import vueStep from 'vue-step';
import MultipleFileUploader from '@updivision/vue2-multi-uploader';
import IdxCard from '@/components/molecules/idx-card';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

const serialize = require('form-serialize');
const n = require('normalize-strings');

export default {
  components: { IdxCard, MultipleFileUploader, draggable, vueStep },
  watch: {
    submitFile: function watchFile(file) {
      if (file && file.type === 'text/csv' || file.type === 'text/plain' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.loadTextFromFile(file);
        this.disableSubmitButton = false;
      } else {
        this.$refs['file-input'].reset();

        swal({
          title: 'Atenção!',
          text: 'Aceitamos apenas arquivos que sejam .txt .xlsx e .csv',
          icon: 'warning',
        });
      }
    },

    date: function watchDate(value) {
      this.$store.state.actions.scheduleInfo.formattedDate = new Date(
        `${this.dateFormatSubmit(value)}T${this.scheduleInfo.time}:00`,
      );
    },
    'scheduleInfo.time': function watchTime(value) {
      const hour = value.substring(0, 2);
      if (parseInt(hour, 10) > 23) {
        this.$store.state.actions.scheduleInfo.time = '00:00';
      }
      this.$store.state.actions.scheduleInfo.formattedDate = new Date(
        `${this.dateFormatSubmit(this.date)}T${value}:00`,
      );
    },
    submitClients: function watchItems(value) {
      if (value.length !== 0) {
        this.disableSubmitButton = false;
      }
    },
  },
  computed: {
    ...mapFields('actions', [
      'listId',
      'action',
      'isResubmit',
      'schedule',
      'scheduleInfo',
      'submitButton',
      'actionGroupData',
    ]),
    ...mapState('companies', ['company', 'myMetric']),
    ...mapState('settings', ['switchReply']),
    ...mapState('indicators', ['actionIndicators']),
    ...mapFields('submit', [
      'submitFile',
      'submitClients',
      'manualClients',
      'columns',
    ]),
  },
  data: () => ({
    loading: false,
    checkQuota: false,
    allIh1Disabled: false,
    allMapDisabled: false,
    allIh2Disabled: false,
    allClientIdDisabled: false,
    anonymousDisabled: false,
    dragging: false,
    date: new Date(),
    sending: false,
    actionId: null,
    toastCount: 0,
    userAuth: null,
    columnName: null,
    fileLength: 0,
    totalCustomers: 0,
    indicators: [],
    fields: [],
    submitFile: null,
    options: {
      ih: null,
      date: false,
      map: false,
      report: false,
      clientId: false,
      anonymous: true,
    },
    ih1: false,
    ih2: false,
    disableSubmitButton: true,
    indicatorHeaders: [],
    countryLanguage: 'pt',
    dateCheked: false,
  }),
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    const response = await api.get(`/action/${this.$route.params.id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });
    this.action = {
      ...response.data,
    };
    await this.getIndicators({
      token: this.userAuth.token,
      actionId: this.action._id,
    });
    if (this.action._id) {
      this.checkIndicators();
    }
    this.indicatorHeaders = [
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.filial.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.filial.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.ih2.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.ih2.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.report.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.report.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.map.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.map.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.date.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.date.content'),
      },
      {
        header: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.header',
        ),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.content',
        ),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.clientId.header'),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.clientId.content',
        ),
      },
      {
        header: this.$t(
          'newAction.stepThree.indicatorHeaders.expiration.header',
        ),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.expiration.content',
        ),
      },
      {
        header: 'Anonimizar',
        content:
          'Ao selecionar você pode visualizar ou não os indicadores de respostas anonimas',
      },
    ];
    this.changeCalendarLanguage();
  },
  methods: {
    ...mapActions('actions', ['submit', 'submitImportFile', 'getAllActions']),
    habilitAnonymous(indicatorId, clientIdEnabled) {
      if (clientIdEnabled) {
        this.indicators.forEach((el) => {
          if (el.id === indicatorId) {
            el.anonymous = true;
          }
        });
      }
    },

    closeModal() {
      this.columns[2].value = null;
    },
    async handleSubmit() {
      // check if action is paused
      if (this.action.paused) {
        swal({
          title: 'Opss!',
          text: this.$t('newAction.stepThree.actionPaused'),
          icon: 'error',
          dangerMode: true,
        });
        return;
      }
      this.disableSubmitButton = true;
      this.checkQuota = true;
      const consumptions = await this.getCompanyConsumption();
      this.checkQuota = false;
      let exceededQuotaEmail = false;
      let exceededQuotaSms = false;
      let balanceEmail = 0;
      let balanceSms = 0;
      let balanceMsg = 0;
      const totalInvites = this.submitClients.length + this.fileLength;
      // check email balance
      if (this.action.channel === 'email') {
        balanceEmail = consumptions.plan.qtyEmail - consumptions.totalEmail;
        if (balanceEmail < 0) {
          balanceEmail = 0;
        }
        if (totalInvites > balanceEmail) {
          exceededQuotaEmail = true;
        }
      }
      // check sms balance
      if (this.action.channel === 'sms') {
        balanceSms = consumptions.plan.qtySms - consumptions.totalSms;
        if (balanceSms < 0) {
          balanceSms = 0;
        }
        if (totalInvites > balanceSms) {
          exceededQuotaSms = true;
        }
      }
      // check email or sms balance
      if (this.action.channel === 'emailsms') {
        balanceEmail = consumptions.plan.qtyEmail - consumptions.totalEmail;
        balanceSms = consumptions.plan.qtySms - consumptions.totalSms;
        if (balanceEmail < 0) {
          balanceEmail = 0;
        }
        if (balanceSms < 0) {
          balanceSms = 0;
        }
        if (totalInvites > balanceEmail && totalInvites > balanceSms) {
          exceededQuotaEmail = true;
          exceededQuotaSms = true;
        }
        if (totalInvites > balanceEmail && totalInvites <= balanceSms) {
          exceededQuotaEmail = true;
          exceededQuotaSms = false;
        }
        if (totalInvites <= balanceEmail && totalInvites > balanceSms) {
          exceededQuotaEmail = false;
          exceededQuotaSms = true;
        }
      }
      if (this.action.channel === 'email' && exceededQuotaEmail) {
        balanceMsg = balanceEmail;
      } else if (this.action.channel === 'sms' && exceededQuotaSms) {
        balanceMsg = balanceSms;
      } else if (
        this.action.channel === 'emailsms' &&
        exceededQuotaEmail &&
        exceededQuotaSms
      ) {
        balanceMsg = `${balanceEmail} para email e ${balanceSms} para sms`;
      }
      this.disableSubmitButton = false;
      if (
        (this.action.channel === 'email' && exceededQuotaEmail) ||
        (this.action.channel === 'sms' && exceededQuotaSms) ||
        (this.action.channel === 'emailsms' &&
          exceededQuotaEmail &&
          exceededQuotaSms)
      ) {
        swal({
          title: this.$t('newAction.stepThree.messages.exceeded.title'),
          text: this.$t('newAction.stepThree.messages.exceeded.description', {
            totalInvites: `${totalInvites}`,
            balanceMsg: `${balanceMsg}`,
          }),
          icon: 'error',
          dangerMode: true,
        });
        return;
      }
      // eslint-disable-next-line
      if (this.schedule === 'after' && !this.scheduleInfo.time) {
        document.getElementById('schedule-time').classList.add('is-invalid');
      } else {
        try {
          if (this.submitFile) {
            await this.submitImportFile({
              actionId: this.action._id,
              companyId: this.userAuth.companyId,
              token: this.userAuth.token,
              importFile: this.submitFile,
              data: {
                totalCustomers: this.totalCustomers,
                date:
                  this.schedule === 'now'
                    ? null
                    : this.scheduleInfo.formattedDate,
              },
            });
          } else {
            await this.submit({
              actionId: this.action._id,
              companyId: this.userAuth.companyId,
              token: this.userAuth.token,
              data: {
                customers: this.submitClients,
                date:
                  this.schedule === 'now'
                    ? null
                    : this.scheduleInfo.formattedDate,
              },
            });
          }
          if (
            this.action.channel === 'emailsms' &&
            !exceededQuotaEmail &&
            exceededQuotaSms
          ) {
            swal({
              title: this.$t('newAction.stepThree.messages.warning.title'),
              text: this.$t(
                'newAction.stepThree.messages.warning.description',
                {
                  channel1: 'email',
                  channel2: 'sms',
                },
              ),
              icon: 'warning',
            }).then(() => {
              this.switchReply.promoters = false;
              this.switchReply.neutral = false;
              this.switchReply.detractors = false;
              this.$store.state.actions.isResubmit = false;
              this.$router.push('/action-list');
            });
            return;
          } else if (
            this.action.channel === 'emailsms' &&
            exceededQuotaEmail &&
            !exceededQuotaSms
          ) {
            swal({
              title: this.$t('newAction.stepThree.messages.warning.title'),
              text: this.$t(
                'newAction.stepThree.messages.warning.description',
                {
                  channel1: 'sms',
                  channel2: 'email',
                },
              ),
              icon: 'warning',
            }).then(() => {
              this.switchReply.promoters = false;
              this.switchReply.neutral = false;
              this.switchReply.detractors = false;
              this.$store.state.actions.isResubmit = false;
              this.$router.push('/action-list');
            });
            return;
          }
          swal(
            this.$t('newAction.stepThree.messages.shots.title'),
            this.$t('newAction.stepThree.messages.shots.description'),
            'success',
          ).then(() => {
            this.switchReply.promoters = false;
            this.switchReply.neutral = false;
            this.switchReply.detractors = false;
            this.$store.state.actions.isResubmit = false;
            this.$router.push('/action-list');
          });
        } catch (error) {
          window.console.log(error);
        }
        this.submitFile = null;
        // this.submitClients = [];
        this.manualClients = [];
        this.$store.state.actions.schedule = 'now';
        this.$store.state.actions.scheduleInfo.time = '00:00';
        this.getAllActions({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          params: {
            type: this.myMetric,
            groupId: this.actionGroupData._id,
          },
        });
      }
    },
    async handleSort() {
      await this.sortIndicator({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        indicators: this.indicators,
      });
      this.loading = true;
      await this.getIndicators({
        token: this.userAuth.token,
        actionId: this.action._id,
      });
      await this.checkIndicators();
      this.loading = false;
    },
    async indicatorRules(type, indicatorId, isChecked) {
      if (indicatorId) {
        try {
          if (isChecked) {
            if (type === 'ih1') {
              this.allIh1Disabled = true;
            }
            if (type === 'map') {
              this.allMapDisabled = true;
            }
            if (type === 'ih2') {
              this.allIh2Disabled = true;
            }
            if (type === 'clientId') {
              this.allClientIdDisabled = true;
            }
            if (type === 'expiration') {
              this.allMapDisabled = true;
            }
            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }
            await this.addTypeToIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          } else {
            if (type === 'ih1') {
              this.allIh1Disabled = false;
            }
            if (type === 'map') {
              this.allMapDisabled = false;
            }
            if (type === 'ih2') {
              this.allIh2Disabled = false;
            }
            if (type === 'clientId') {
              this.allClientIdDisabled = false;
            }
            if (type === 'expiration') {
              this.allClientIdDisabled = false;
            }
            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }
            await this.removeTypeFromIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          }
        } catch (error) {
          const myIndicator = this.indicators.find(
            (el) => el.id === indicatorId,
          );
          myIndicator[type] = !isChecked;
          swal({
            title: this.$t('newAction.stepThree.messages.dangerMode.title'),
            text: this.$t(
              'newAction.stepThree.messages.dangerMode.description',
            ),
            icon: 'error',
            dangerMode: true,
          });
        }
      }
    },
    onClick() {
      this.$refs.dropdown.hide(true);
    },
    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy');
      return date;
    },
    dateFormatSubmit(param) {
      const date = format(param, 'yyyy-MM-dd');
      return date;
    },
    downloadModel() {
      const columns = this.columns.map((res) => res);
      this.downloadFile({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        actionId: this.action._id,
        columns,
      });
    },
    ...mapActions('actions', [
      'uploadFiles',
      'setMalling',
      'setColumns',
      'downloadFile',
      'getMallingInfo',
      'deleteMallingInfo',
    ]),
    ...mapActions('indicators', [
      'setIndicators',
      'getIndicators',
      'addTypeToIndicator',
      'removeTypeFromIndicator',
      'sortIndicator',
      'deleteIndicator',
    ]),
    makeToast(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errorMessage.description'),
        {
          title: this.$t('newAction.stepThree.messages.errorMessage.title'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },
    makeToastNumber(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidNumber'),
        {
          title: this.$t('newAction.stepThree.messages.errorMessage.title'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },
    makeToastColumnName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidColumn'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },
    makeToastInvalidName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidCharacters'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },
    // eslint-disable-next-line
    insertUser() {
      const form = document.querySelector('#frm-newUser');
      const obj = serialize(form, { hash: true });
      if (obj.telefone) {
        // eslint-disable-next-line
        obj.telefone = parseInt(obj.telefone.replace(/\D/g, ''));
        if (obj.telefone.length > 13) {
          this.makeToastNumber();
          return false;
        }
      }
      this.columns[1].value = '';
      if (obj.email == null || obj.email === undefined) {
        this.submitClients.push(obj);
        this.manualClients.push(obj);
        this.$store.state.actions.clientsCount += 1;
        swal({
          title: this.$t('newAction.stepThree.messages.addClientSuccess.title'),
          text: this.$t(
            'newAction.stepThree.messages.addClientSuccess.description',
          ),
          icon: 'success',
        });
      } else if (validator.isEmail(obj.email)) {
        this.submitClients.push(obj);
        this.manualClients.push(obj);
        this.$store.state.actions.clientsCount += 1;
        swal({
          title: this.$t('newAction.stepThree.messages.addClientSuccess.title'),
          text: this.$t(
            'newAction.stepThree.messages.addClientSuccess.description',
          ),
          icon: 'success',
        });
      } else {
        swal({
          title: this.$t('newAction.stepThree.messages.emailInvalid.title'),
          text: this.$t(
            'newAction.stepThree.messages.emailInvalid.description',
          ),
          icon: 'warning',
        });
      }
    },
    consistFone(fone) {
      let newFone = `${fone}`;
      // retirar caracteres especiais: retorna apenas os digitos
      newFone = parseInt(newFone.replace(/([^0-9])/g, ''), 10);
      return newFone;
    },

    dateIsChecked() {
      if (this.indicators && this.indicators.length > 0) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (this.indicators[i].date) {
            this.dateCheked = true;
            break;
          } else {
            this.dateCheked = false;
          }
        }
      }
    },

    async loadTextFromFile(file) {
      const reader = new FileReader();
      try {
        await reader.readAsArrayBuffer(file);
        // this method is to open loading modal
        this.$refs.processingModal.show();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const arr = [];
          for (let i = 0; i !== data.length; i += 1) {
            arr[i] = String.fromCharCode(data[i]);
          }
          const bstr = arr.join('');
          const workbook = XLSX.read(bstr, {
            type: 'binary',
          });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            raw: true,
          });
          if (json.length > 10) {
            for (let i = 0; i < 10; i += 1) {
              Object.keys(json[i]).forEach((key) => {
                const fieldDate = this.columns.find(
                  (item) => item.key === key && item.date === true,
                );
                if (fieldDate) {
                  if (json[i][key]) {
                    json[i][key] = json[i][key].toString().trim();
                    if (json[i][key] === '') {
                      json[i][key] = null;
                    }
                    if (json[i][key]) {
                      const time = new Date('1900-01-01');
                      const sum = time.getDate() - 1;
                      const days = parseInt(json[i][key], 10);
                      time.setDate(sum + days);
                      json[i][key] = format(time, 'dd/MM/yyyy');
                    }
                  }
                }
              });
              if (json[i].telefone) {
                json[i].telefone = this.consistFone(json[i].telefone);
              }
              this.submitClients.push(json[i]);
            }
          } else if (this.submitClients.length === 0) {
            json.forEach((obj) => {
              Object.keys(obj).forEach((key) => {
                const fieldDate = this.columns.find(
                  (item) => item.key === key && item.date === true,
                );
                if (fieldDate) {
                  if (obj[key]) {
                    obj[key] = obj[key].toString().trim();
                    if (obj[key] === '') {
                      obj[key] = null;
                    }
                    if (obj[key]) {
                      const time = new Date('1900-01-01');
                      const sum = time.getDate() - 1;
                      const days = parseInt(obj[key], 10);
                      time.setDate(sum + days);
                      obj[key] = format(time, 'dd/MM/yyyy');
                    }
                  }
                }
              });
              if (obj.telefone) {
                obj.telefone = this.consistFone(obj.telefone);
              }
            });
            this.submitClients = json;
          } else {
            json.forEach((obj) => {
              Object.keys(obj).forEach((key) => {
                const fieldDate = this.columns.find(
                  (item) => item.key === key && item.date === true,
                );
                if (fieldDate) {
                  if (obj[key]) {
                    obj[key] = obj[key].toString().trim();
                    if (obj[key] === '') {
                      obj[key] = null;
                    }
                    if (obj[key]) {
                      const time = new Date('1900-01-01');
                      const sum = time.getDate() - 1;
                      const days = parseInt(obj[key], 10);
                      time.setDate(sum + days);
                      obj[key] = format(time, 'dd/MM/yyyy');
                    }
                  }
                }
              });
              if (obj.telefone) {
                obj.telefone = this.consistFone(obj.telefone);
              }
              this.submitClients.push(obj);
            });
          }
          this.$store.state.actions.clientsCount += json.length;
          this.fileLength = json.length - 10;
          this.totalCustomers = json.length;
          // this method is to close loading modal
          this.$refs.processingModal.hide();
        };
      } catch (err) {
        window.console.log(err);
      }
    },

    returnText(values) {
      let names = '';
      for (let i = 0; i < values.length; i += 1) {
        names = names.concat(
          `Erro na linha: ${i}, cliente: ${values[i].nome} \n`,
        );
      }
      return names;
    },
    disableSendingFunction() {
      this.sending = false;
    },
    async addColumn() {
      const regex = /^(?=.*[.$])/; // mongo issue -> key does not allow "." or "$"
      if (this.columnName) {
        const item = this.indicators.find(
          (obj) => obj.label === this.columnName,
        );
        if (regex.test(this.columnName)) {
          this.makeToastInvalidName();
        } else if (
          !item &&
          this.columnName.toLowerCase() !== 'nome' &&
          this.columnName.toLowerCase() !== 'email' &&
          this.columnName.toLowerCase() !== 'telefone'
        ) {
          this.sending = true;
          try {
            this.loading = true;
            await this.setIndicators({
              token: this.userAuth.token,
              actionId: this.action._id,
              companyId: this.userAuth.companyId,
              data: {
                name: this.columnName,
              },
            });
            this.indicators.push({
              // eslint-disable-next-line
              key: n(this.columnName).toLowerCase().replace(/\ /gi, '_'),
              label: this.columnName,
              branch: this.options.ih,
              map: this.options.map,
              date: this.options.date,
              report: this.options.report,
              clientId: this.options.clientId,
              expiration: this.options.expiration,
              sortable: true,
              anonymous: this.options.anonymous,
            });
            await this.getIndicators({
              token: this.userAuth.token,
              actionId: this.action._id,
            });
            await this.checkIndicators();
            this.columnName = null;
            this.options.ih = null;
            this.options.map = false;
            this.options.date = false;
            this.options.report = false;
            this.options.clientId = false;
            this.options.expiration = false;
            this.options.anonymous = true;
            this.ih1 = false;
            this.ih2 = false;
            this.columns = this.fields;
            this.columns = this.columns.concat(this.indicators);
            this.loading = false;
          } catch (error) {
            window.console.log('houve um erro');
          }
          this.disableSendingFunction();
        } else {
          this.columnName = null;
          this.makeToastColumnName();
        }
      }
    },
    async removeColumn(index, indicatorId) {
      swal({
        title: this.$t('newAction.stepThree.messages.removeColumn.title'),
        text: this.$t('newAction.stepThree.messages.removeColumn.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteIndicator({
            token: this.userAuth.token,
            indicatorId,
          });
          await this.getIndicators({
            token: this.userAuth.token,
            actionId: this.action._id,
          });
          await this.checkIndicators();
          this.columns = this.fields.concat(this.indicators);
          swal({
            title: this.$t('newAction.stepThree.messages.success.title'),
            text: this.$t('newAction.stepThree.messages.success.description'),
            icon: 'success',
          });
        }
      });
    },
    async checkIndicators() {
      this.indicators = [];
      if (this.actionIndicators) {
        this.actionIndicators.forEach((el) => {
          if (
            el.key !== 'nome' &&
            el.key !== 'email' &&
            el.key !== 'telefone'
          ) {
            this.indicators.push({
              key: el.key,
              position: el.position,
              label: el.name,
              ih1: el.types.indexOf('ih1') === -1 ? false : true,
              ih2: el.types.indexOf('ih2') === -1 ? false : true,
              report: el.types.indexOf('report') === -1 ? false : true,
              map: el.types.indexOf('map') === -1 ? false : true,
              date: el.types.indexOf('date') === -1 ? false : true,
              auxiliary: el.types.indexOf('auxiliary') === -1 ? false : true,
              clientId: el.types.indexOf('clientId') === -1 ? false : true,
              expiration: el.types.indexOf('expiration') === -1 ? false : true,
              anonymous:
                el.types.indexOf('anonymous') === -1
                  ? el.anonymous
                  : el.anonymous,
              id: el._id,
            });
          }
        });
        const ih1Exists = this.indicators.find((el) => el.ih1);
        if (ih1Exists) {
          this.allIh1Disabled = true;
        }
        const mapExists = this.indicators.find((el) => el.map);
        if (mapExists) {
          this.allMapDisabled = true;
        }
        const ih2Exists = this.indicators.find((el) => el.ih2);
        if (ih2Exists) {
          this.allIh2Disabled = true;
        }
        const clientIdExists = this.indicators.find((el) => el.clientId);
        if (clientIdExists) {
          this.allClientIdDisabled = true;
        }
        const expirationExists = this.indicators.find((el) => el.expiration);
        if (expirationExists) {
          this.allMapDisabled = true;
        }
        const anonymousIndicator = this.indicators.find((el) => el.anonymous);
        if (anonymousIndicator) {
          this.anonymousDisabled = false;
        }
        this.columns.splice(3);
        this.columns = this.columns.concat(this.indicators);
      }
    },
    cleanTable() {
      if (this.submitClients.length !== 0) {
        swal({
          title: this.$t('newAction.stepThree.messages.deleteList.title'),
          text: this.$t('newAction.stepThree.messages.deleteList.description'),
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            if (this.submitFile) {
              this.submitFile = null;
            }
            // else {
            //   await this.deleteMallingInfo({
            //     token: this.userAuth.token,
            //     companyId: this.userAuth.companyId,
            //     actionId: this.actionId,
            //   });
            // }
            this.submitClients = [];
            this.manualClients = [];
            this.fileLength = 0;
            this.$store.state.actions.clientsCount = 0;
          }
        });
      }
    },
    async getCompanyConsumption() {
      const response = await api.get(`consumption/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      return response.data.consumption;
    },
    changeCalendarLanguage() {
      switch (this.$i18n.locale) {
        case 'br':
          this.countryLanguage = 'pt';
          break;
        case 'co':
          this.countryLanguage = 'es';
          break;
        case 'us':
          this.countryLanguage = 'en';
          break;
        default:
          break;
      }
    },
    saveChanges() {
      swal({
        title: this.$t('newAction.stepOne.actionSavedAlert'),
        text: this.$t('newAction.stepThree.wish'),
        icon: 'success',
        buttons: {
          leave: {
            text: this.$t('newAction.stepThree.cancel'),
            value: 'cancel',
          },
          next: {
            text: this.$t('newAction.stepThree.continueAfter'),
            value: 'skip',
          },
        },
      }).then((value) => {
        if (value === 'skip') {
          this.$router.push('/action-list');
        }
      });
    },
  },
  async mounted() {
    EventBus.$on('changedLanguage', () => {
      this.changeCalendarLanguage();
    });
    this.$store.state.actions.scheduleInfo.formattedDate = new Date();
    this.$store.state.actions.clientsCount = 0;
    this.submitFile = null;
    this.submitClients = [];
    this.manualClients = [];
    this.fields = [
      {
        key: 'nome',
        label: this.$t('newAction.stepThree.labels.personName'),
        sortable: true,
      },
      {
        key: 'email',
        label: this.$t('newAction.stepThree.labels.personEmail'),
        sortable: true,
      },
      {
        key: 'telefone',
        label: this.$t('newAction.stepThree.labels.personPhone'),
        sortable: true,
      },
    ];
    this.columns = this.fields;
  },
};
</script>

<style lang="scss">
.ellipsis {
  color: #c1c1c1;
}
.ellipsis:hover {
  cursor: all-scroll;
}
.drop-indicators .dropdown-menu {
  width: 100%;
}
.drop-indicators .btn-outline-primary {
  &:hover {
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
td,
th {
  text-align: center;
}
td:first-child,
th:first-child {
  text-align: left;
}
.footer-buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.add-user {
  color: $primary;
  font-size: 21px;
  cursor: pointer;
}
.add-column-area {
  display: flex;
  flex-direction: row;
}
.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 8px 24px;
  border-radius: 4px;
  margin: 8px;
}
.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  display: flex;
  align-items: center;
}
.closebtn {
  padding-left: 10px;
  color: $white;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
.chips-columns {
  height: 40px;
}
.more-items {
  h5 {
    color: $white;
    background-color: $primary;
    padding: 10px;
    margin-top: -15px;
    text-align: right;
  }
}
.submit-action {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.schedule-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  input {
    max-width: 110px;
  }
}
button {
  &:hover {
    color: $white;
  }
}
.indicator-th {
  position: relative;
}
.indicator-info-icon {
  margin-left: 5px;
  position: absolute;
  top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/step-three/index.vue